import React from 'react';

const Picture = ({
  bitmapSrc,
  bitmapSrc2x,
  webpSrc,
  webpSrc2x,
  alt,
  className,
  ...props
}) => {
  let bitmapSrcSet = bitmapSrc;
  let webpSrcSet = webpSrc;

  if (bitmapSrc2x) {
    bitmapSrcSet += `, ${bitmapSrc2x} 2x`;
  }

  if (webpSrc2x) {
    webpSrcSet += `, ${webpSrc2x} 2x`;
  }
  const bitmapSrcArray = bitmapSrc.split('.');

  return (
    <picture className={className}>
      <source srcSet={webpSrcSet} type="image/webp" />
      <source
        srcSet={bitmapSrcSet}
        type={`image/${bitmapSrcArray[bitmapSrcArray.length - 1]}`}
      />
      <img src={bitmapSrc} alt={alt} {...props} loading="lazy" />
    </picture>
  );
};

export default Picture;
